import { useScopedDialog } from '~/composables/use-scoped-dialog'
import EditProfile from '~/components/Modals/EditProfile/EditProfile.vue'
import { useI18n } from 'vue-i18n'

export function useEditProfileModal(): () => Promise<void> {
    const dialog = useScopedDialog()
    const { t } = useI18n({ useScope: 'global' })

    return () => {
        return new Promise(resolve => {
            dialog.open(EditProfile, {
                props: {
                    header: t('layout.profileSettings'),
                    modal: true,
                    pt: {
                        root: {
                            class: 'w-full h-max-md:h-full max-h-full !rounded-none md:!w-[40rem] md:!h-[30rem]'
                        },
                        header: {
                            class: '!rounded-none text-xl font-semibold'
                        },
                        content: {
                            class: '!rounded-none flex-1 '
                        }
                    },
                    ptOptions: {
                        mergeProps: true
                    }
                },
                onClose: () => {
                    resolve()
                }
            })
        })
    }
}
